<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <c-panel-container>
          <c-panel :title="versionText" :img="versionImg"></c-panel>
        </c-panel-container>
        <c-title-line :title="textTitle" :class="[noBorder ? 'no-border' : '']"></c-title-line>
        <c-button-recharge
                :title="needMoney"
                :desc="everyNeedMoney"
                :commend="btnColor"
        ></c-button-recharge>
        <c-title-line :title="`* ${this.leftDate}天后恢复原价：￥${this.relMoney}/年（￥￥${this.relEveryDayMoney}/天）`"
                      v-if="ifShowLeftDate"
                      :class="[noBorder ? 'no-border' : '']"></c-title-line>
        <c-button @click.native="buy">
          <div>{{ btnText }}</div>
        </c-button>
      </c-content>
    </c-page>
    <transition name="slide-right" mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import CButtonRecharge from '../../../components/c-button/recharge/index'
  import RenewalObj from '../../../model/order/renewal/index'
  import Pay from '../../../model/pay'

  export default {
    data () {
      let pay = new Pay()
      return {
        id: '',
        noBorder: true,
        btnColor: true,
        versionText: '',
        versionImg: '',
        textTitle: '选择时长',
        needMoney: '',
        everyNeedMoney: '',
        btnText: '立即购买',
        leftDate: '',
        relMoney: '',
        renewalObj: new RenewalObj(),
        pay
      }
    },
    components: {CButtonRecharge},
    created () {
    },
    mounted () {
      this.id = this.$route.params.id
      this.getDate()
    },
    beforeDestroy () {
    },
    methods: {
      getDate () {
        this.renewalObj.getBusInfo(this.id).then(res => {
          this.versionText = res.versionText
          this.versionImg = res.versionImg
          this.relMoney = res.relMoney
          this.relEveryDayMoney = res.relEveryDayMoney
          this.needMoney = res.needMoney
          this.everyNeedMoney = res.everyNeedMoney
        })
        this.renewalObj.getOrderSaasCount().then(res => {
          this.leftDate = res.leftDate
        })
      },
      buy () {
        this.pay.rechargeSaas(this.id, 12)
      }
    },
    computed: {
      ifShowLeftDate () {
        return this.leftDate > 0
      }
    },
    watch: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?998b6848